import { useEffect, useState } from 'react';

export function ManageNavigation(
    interaction,
    changerEtapeRemerciement,
    changerAfficherEtapeGRPD,
    changerAfficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeTemoinage
) {
    const [continueEnabled, setContinueEnabled] = useState(false)
    // valeur à utiliser collect_data, collect_user_informations, collect_consent, collect_testimonial, remerciement
    const [pageCourrante, setPageCourrante] = useState('accueil');
    const [pagesSuivantes, setPagesSuivantes] = useState(['collect_data', 'collect_testimonial', 'collect_user_informations', 'collect_consent', 'remerciement']);

    /** Retourne la liste du nom des pages autorisées
     * 
     * @param {string} page pour laquelle on recherche la liste des pages autorisées
     * @returns 
     */
    const getPagesSuivantesAutorisees = (page) => {
        const navigationAutorisee = {
            'accueil': ['collect_data'],
            'collect_data': ['collect_testimonial', 'collect_user_informations', 'collect_consent', 'remerciement'],
            'collect_testimonial': ['collect_user_informations', 'collect_consent', 'remerciement'],
            'collect_user_informations': ['collect_consent', 'remerciement'],
            'collect_consent': ['remerciement']
        }
        const pagesPossibles = navigationAutorisee[page];
        return pagesPossibles;
    }

    /** Réinitialiser les variables de navigation (suite à l'utilisation du bouton retour)
     * 
     */
    const reinitPage = () => {
        console.log('reinitPage');
        setPageCourrante('accueil');
        setPagesSuivantes(['collect_data', 'collect_testimonial', 'collect_user_informations', 'collect_consent', 'remerciement']);
    }


    /** Permet de réaliser le changement de page en fonction de la configuration de l'interaction
     * 
     */
    const changerPage = () => {
        console.log(pagesSuivantes);
        if (interaction.testimonial_demanded && pageCourrante !== 'collect_testimonial' && pagesSuivantes.indexOf('collect_testimonial') >= 0) {
            console.log("testimonial");
            setPageCourrante('collect_testimonial');
            setPagesSuivantes(getPagesSuivantesAutorisees('collect_testimonial'));
            changerAfficherEtapeTemoinage();
        }
        else if (interaction.gather_information && pageCourrante !== 'collect_user_informations' && pagesSuivantes.indexOf('collect_user_informations') >= 0) {
            console.log("personnale info");
            setPageCourrante('collect_user_informations');
            setPagesSuivantes(getPagesSuivantesAutorisees('collect_user_informations'));
            changerAfficherEtapeCollectInformationsPersonnelles()
        }
        else if (interaction.is_gdpr_consent && pageCourrante !== 'collect_consent' && pagesSuivantes.indexOf('collect_consent') >= 0) {
            setPageCourrante('collect_consent');
            setPagesSuivantes(getPagesSuivantesAutorisees('collect_consent'));
            changerAfficherEtapeGRPD()
            console.log("rgpd");
        }
        else if (interaction.is_image_right_consent && pageCourrante !== 'collect_consent' && pagesSuivantes.indexOf('collect_consent') >= 0) {
            setPageCourrante('collect_consent');
            setPagesSuivantes(getPagesSuivantesAutorisees('collect_consent'));
            changerAfficherEtapeGRPD()
            console.log("image right");
        }
        else {
            setPageCourrante('remeciement');
            console.log("remerciement");
            changerEtapeRemerciement()
        }
    }
    /** Retourne vrai lorsque la page est la dernière sur laquelle effectuer
     * l'action de sauvegarde en fonction des paramètres de l'interactions
     * 
     * @param {string} page les valeurs possibles :
     *   collect_data, collect_user_informations, collect_consent, collect_testimonial
     */
    const estDernierePagePourSauver = (page) => {
        if (page === 'collect_data') {
            return !interaction.gather_information && !interaction.is_gdpr_consent && !interaction.is_image_right_consent && !interaction.testimonial_demanded;
        }
        if (page === 'collect_testimonial') {
            return !interaction.gather_information && !interaction.is_gdpr_consent && !interaction.is_image_right_consent;
        }
        if (page === 'collect_user_informations') {
            return !interaction.is_gdpr_consent && !interaction.is_image_right_consent;
        }
        if (page === 'collect_consent') {
            return true;
        }

    }
    return {
        changerPage,
        reinitPage,
        continueEnabled,
        pageCourrante,
        setPageCourrante,
        setContinueEnabled,
        estDernierePagePourSauver
    }
}